import { useEffect } from "react";
import { motion } from "framer-motion";
import { Instagram, Mail } from "lucide-react";
import ContactForm from "@/components/site/ContactForm";
import { SITE } from "@/constants/site";
import { CONTACT } from "@/constants/testIds";

const Contact = () => {
  useEffect(() => {
    document.title = "TWGAS · Contact";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main
      data-testid={CONTACT.root}
      className="bg-[#0A0A0A] pt-32 md:pt-40 pb-24 md:pb-32"
    >
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <div className="num-tag mb-4">/ CONTACT · 01</div>
            <motion.h1
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="font-display uppercase text-6xl md:text-8xl leading-[0.86] tracking-tight"
            >
              Let's
              <br />
              work.
            </motion.h1>
            <p className="mt-6 text-zinc-400 text-base md:text-lg leading-relaxed max-w-[42ch]">
              Tell us about the athlete. Sport, school, and the goal for the
              next 12 months. We'll take it from there.
            </p>

            <ul className="mt-10 space-y-4">
              <li>
                <a
                  href={SITE.instagramUrl}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={CONTACT.instagramCta}
                  className="group flex items-center justify-between border-t border-white/10 pt-4 hover:text-[#FF4D00] transition-colors"
                >
                  <span className="flex items-center gap-3">
                    <Instagram size={16} />
                    <span className="font-display uppercase text-2xl md:text-3xl">
                      {SITE.instagramHandle}
                    </span>
                  </span>
                  <span className="font-mono-plex text-[10px] tracking-[0.28em] uppercase text-zinc-500 group-hover:text-[#FF4D00]">
                    DM
                  </span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${SITE.ownerEmail}`}
                  className="group flex items-center justify-between border-t border-white/10 pt-4 hover:text-[#FF4D00] transition-colors"
                >
                  <span className="flex items-center gap-3">
                    <Mail size={16} />
                    <span className="font-display uppercase text-2xl md:text-3xl">
                      Email
                    </span>
                  </span>
                  <span className="font-mono-plex text-[10px] tracking-[0.28em] uppercase text-zinc-500 group-hover:text-[#FF4D00]">
                    {SITE.ownerEmail}
                  </span>
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-7">
            <ContactForm />
          </div>
        </div>
      </div>
    </main>
  );
};

export default Contact;
